import { ChatChannelCreateRequestDto, ChatChannelResponseDto } from '@diritto/common/chat/dtos/chat-channel.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ChatPartnerApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getChannelByContentId(contentId: number) {
    const res = await this.http.get<ChatChannelResponseDto>(`${this.url}/chat/partner/contents/${contentId}`);
    return res.data;
  }

  async postChannel(dto: ChatChannelCreateRequestDto) {
    const res = await this.http.post<ChatChannelCreateRequestDto, ChatChannelResponseDto>(
      `${this.url}/chat/partner/channels`,
      dto,
    );
    return res.data;
  }
}
